import { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { FarmFragment } from '../../../generated/types';

interface FarmDescriptionProps {
  data: FarmFragment;
}

export const FarmDescription: FC<FarmDescriptionProps> = ({ data }) => {
  if (!data.farmDescription) return null;

  return (
    <Box
      mt={3}
      mb={9}
      dangerouslySetInnerHTML={{
        __html: data.farmDescription,
      }}
    />
  );
};
